import { CarTypesEnum } from '@/components/car-details-v2/car-type';
import useTranslationHook from '@/hook/use-translation-client.hook';
import myImageLoader from '@/image.loader';
import { CarDetailsType } from '@/types';
import { CarTypeBadge } from '../CarTypeBadge/CarTypeBadge';

export const CarDetailsHeader = ({
    title,
    selectedCar,
    carType,
}: {
    title: string;
    selectedCar: CarDetailsType;
    carType: CarTypesEnum;
}) => {
    const { t } = useTranslationHook();
    const { make, model, year } = selectedCar;

    return (
        <>
            <div className="flex justify-between items-center w-full">
                <div className="flex gap-x-2 ">
                    <div className="w-[52.94px] rounded overflow-hidden ">
                        <img
                            src={myImageLoader({
                                src: selectedCar?.images[0],
                                width: 100,
                                height: 100,
                                quality: 35,
                            })}
                            alt={'Car Details'}
                            className="w-full"
                        />
                    </div>
                    <div>
                        <div className="text-gray-800 text-body1SemiBold">
                            {title}
                        </div>
                        <div className="text-gray-600 text-captionMedium">
                            {t(make as unknown as TemplateStringsArray)} {model}{' '}
                            {year}
                        </div>
                    </div>
                </div>
                <div className="md:hidden block">
                    <CarTypeBadge carType={carType} className="rounded" />
                </div>
            </div>
        </>
    );
};
